export default {
    getUserSexualPreferences: state => state.userSexualPreferences,
    getUserDesires: state => state.userDesires,

};